/**
 * Tracks passive analytics like app foreground/background time.
 */
export function PassiveAnalytics() {
  return null
}
